"use strict";
import UniswapXRouterLabel from "components/RouterLabel/UniswapXRouterLabel";
import { QuoteMethod } from "state/routing/types";
import { isUniswapXTrade } from "state/routing/utils";
import { ThemedText } from "theme/components";
export default function RouterLabel({ trade, color }) {
  const interFont = { fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif" };
  if (isUniswapXTrade(trade)) {
    return <UniswapXRouterLabel><ThemedText.BodySmall style={interFont}>Uniswap X</ThemedText.BodySmall></UniswapXRouterLabel>;
  }
  if (trade.quoteMethod === QuoteMethod.CLIENT_SIDE_FALLBACK) {
    return <ThemedText.BodySmall color={color} style={interFont}>Swap Client</ThemedText.BodySmall>;
  }
  return <ThemedText.BodySmall color={color} style={interFont}>Swap API</ThemedText.BodySmall>;
}
